// import jQuery from 'CommonScripts/jquery-1.10.2'; 

(function (window, document, $) {
     
    $(document).ready(function () {            

        /* Functionality for the Selector (drop-down). Primarly for language selection. */
       // $.components.registerComponent('section.selector-spot', function ($root) {
        var $root = document.querySelectorAll('section.selector-spot');
        $root = $($root);
            var selector = {
                dom: {
                    select: $root.find('select')
                },
                set: {
                },
                fn: {
                    isUrl: function (str) {
                        return str.indexOf('/') === 0 || str.indexOf('http') === 0;
                    },
                    redirect: function (url) {
                        location.href = url;
                    }
                }
            },
            /* Add quick access variables to be used in local function
             * Keep main variable name in case it needs to be shared with other JS files
             */
            $dom = selector.dom,
            $set = selector.set,
            $fn = selector.fn;

            $dom.select.on({
                change: function () {
                    var str = $(this).val();
                    if ($fn.isUrl(str)) {
                        $fn.redirect(str);
                    }
                }
            });
        //});

    });

})(window, document, jQuery);